document.querySelector('.faq-list').addEventListener('click', (event) => {

  const questionEl = event.target.closest('.faq-question');
  if (!questionEl) return;

  const item = questionEl.closest('.faq-item');
  const answer = item.querySelector('.faq-answer');
  const vertical = item.querySelector('.vertical-line');
  const isHidden = answer.classList.contains('hidden');

  answer.classList.toggle('hidden', !isHidden);
  vertical.classList.toggle('hidden', isHidden);
  questionEl.setAttribute('aria-expanded', String(!isHidden));
}); 